import { Link } from 'react-router-dom';
import { ReactComponent as St5LogoWhite } from '../assets/st5_white.svg';

function Home() {
  return (
    <div className="home-container">
      <section className="home-section home-section--hero">
        <div className="section-inner">
          <div className="logo">
            <St5LogoWhite role="img" aria-label="Smart Transform 5.0" />
          </div>
          <h1>Co-creative Transformation in Richtung Industrie 5.0</h1>

          <div className="project-description">
            <p>
              Smart Transform 5.0 unterstützt kleine und mittlere Unternehmen (KMU) in der Region
              Ostwestfalen-Lippe (OWL) dabei, den Wandel zur Industrie 5.0 erfolgreich und
              praxisnah zu gestalten. In Zeiten von wirtschaftlichem Druck und Fachkräftemangel
              setzt das Projekt auf einen menschzentrierten Ansatz: Moderne Technologien wie KI
              und Automatisierung werden so eingesetzt, dass sie Mitarbeitende gezielt unterstützen,
              statt sie zu ersetzen. Gemeinsam mit Partnern aus Wissenschaft und Transfer werden
              konkrete Use Cases und praxiserprobte Vorgehensmodelle entwickelt, um ökologische
              Nachhaltigkeit, Resilienz und Digitalisierung direkt im Unternehmensalltag zu
              verankern.
            </p>
            <div className="hero-cta">
              <Link to="/selbstcheck" className="hero-cta-button">
                ST5-Selbstcheck starten
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="home-section home-section--gruende gruende-section">
        <div className="section-inner">
          <h2>5 gute Gründe für Ihre Teilnahme</h2>
          <p className="gruende-intro">
            Warum sollte Ihr Unternehmen Teil von Smart Transform 5.0 werden?<br />
            Hier sind die wichtigsten Vorteile auf einen Blick:
          </p>
          <div className="gruende-list">
            <div className="grund-item">
              <div className="grund-title">Praxis statt grauer Theorie</div>
              <p>Sie erhalten keine abstrakten Konzepte, sondern konkrete, praxiserprobte Use Cases und Vorgehensmodelle, die direkt in Ihrem Unternehmen anwendbar sind.</p>
            </div>
            <div className="grund-item">
              <div className="grund-title">Menschzentrierte Innovation</div>
              <p>Wir zeigen Ihnen, wie Sie KI und Automatisierung so einführen, dass Ihre Mitarbeitenden entlastet werden und die Akzeptanz für neue Technologien steigt.</p>
            </div>
            <div className="grund-item">
              <div className="grund-title">Wettbewerbsvorteil Nachhaltigkeit</div>
              <p>Erhalten Sie gezielte Unterstützung dabei, Nachhaltigkeit und regulatorische Anforderungen als echte Erfolgsfaktoren für Ihr Geschäft zu nutzen.</p>
            </div>
            <div className="grund-item">
              <div className="grund-title">Exklusives Experten-Netzwerk</div>
              <p>Profitieren Sie vom direkten Austausch mit anderen KMU aus der Region sowie erfahrenen Expert:innen aus Wissenschaft und Wirtschaftsförderung.</p>
            </div>
            <div className="grund-item">
              <div className="grund-title">Risikofreie Teilnahme</div>
              <p>Die Nutzung aller Projektergebnisse ist für Sie kostenfrei. Es gibt keine Großinvestitionen, keine Verkaufsabsichten und keine langfristigen Verpflichtungen.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="home-section home-section--partners partners-section">
        <div className="section-inner">
          <h2>Geförderte Projektpartner</h2>
          <div className="partners-grid">
            <div className="partner">
              <a href="https://www.ima-gt.de/" target="_blank" rel="noopener noreferrer" className="partner-link">
                <div className="partner-logo">
                  <img src="/logos/ima.svg" alt="IMA Innovationsmanufaktur Gütersloh" />
                </div>
                <h3>IMA Innovationsmanufaktur Gütersloh GmbH</h3>
                <table className="partner-info">
                  <tbody>
                    <tr>
                      <td className="partner-address-cell">
                        Langer Weg 7b<br />
                        33332 Gütersloh
                      </td>
                      <td className="partner-rep-cell">
                        Ansprechpartner:<br />Dipl.-Ing. Jörg Rodehutskors
                      </td>
                    </tr>
                  </tbody>
                </table>
              </a>
            </div>

            <div className="partner">
              <a href="https://www.hsbi.de/" target="_blank" rel="noopener noreferrer" className="partner-link">
                <div className="partner-logo">
                  <img src="/logos/hsbi.svg" alt="Hochschule Bielefeld" />
                </div>
                <h3>Hochschule Bielefeld (HSBI)</h3>
                <table className="partner-info">
                  <tbody>
                    <tr>
                      <td className="partner-address-cell">
                        Interaktion 1<br />
                        33619 Bielefeld
                      </td>
                      <td className="partner-rep-cell">
                        Ansprechpartner:<br />Prof. Dr. Thomas Süße
                      </td>
                    </tr>
                  </tbody>
                </table>
              </a>
            </div>

            <div className="partner">
              <a href="https://www.kognihome.de/" target="_blank" rel="noopener noreferrer" className="partner-link">
                <div className="partner-logo">
                  <img src="/logos/kognihome.svg" alt="KogniHome e.V." />
                </div>
                <h3>KogniHome e.V.</h3>
                <table className="partner-info">
                  <tbody>
                    <tr>
                      <td className="partner-address-cell">
                        Königsweg 1<br />
                        33617 Bielefeld
                      </td>
                      <td className="partner-rep-cell">
                        Ansprechpartner:<br />Prof. Dr. Thorsten Jungeblut
                      </td>
                    </tr>
                  </tbody>
                </table>
              </a>
            </div>

            <div className="partner">
              <a href="https://www.mintkitchen.de/" target="_blank" rel="noopener noreferrer" className="partner-link">
                <div className="partner-logo mintkitchen-logo">
                  <img src="/logos/mintKitchenLogo.svg" alt="MINTkitchen" />
                </div>
                <h3>MINTkitchen KG</h3>
                <table className="partner-info">
                <tbody>
                  <tr>
                    <td className="partner-address-cell">
                      Amselweg 22<br />
                      33178 Borchen
                    </td>
                    <td className="partner-rep-cell">
                      Ansprechpartner:<br />Wilhelm Klat (M.Sc.)
                    </td>
                  </tr>
                </tbody>
              </table>
              </a>
            </div>
          </div>
        </div>
      </section>

      <section className="home-section home-section--funding funding-section">
        <div className="section-inner">
          <h2>Gefördert durch EFRE.NRW</h2>
          <p>
            Dieses Projekt wird gefördert durch das<br />
            EFRE/JTF-Programm NRW 2021–2027 (Regio.NRW – Transformation).
          </p>
          <div className="funding-logo">
            <img src="/logos/efre.svg" alt="EFRE/JTF-Programm NRW" />
            <p className="funding-link">
              <a href="https://www.efre.nrw" target="_blank" rel="noopener noreferrer">→ www.efre.nrw</a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Home;
